<app-navbar [navList]="navList"></app-navbar>

@let existedUser = userDetail();

<div class="qai-content-box overflow-auto">
  <div class="card qai-card qai-card-create shadow-sm">
    <div class="card-body px-4">
      <h4 class="card-title py-3">{{ existedUser ? 'Dettaglio Utente' : 'Nuovo utente'}}</h4>
      <form [formGroup]="userForm" (ngSubmit)="onSubmit()">
        <div class="row mb-3">
          <div class="col-md-6">
            <label for="name" class="form-label">Nome</label>
            <input type="text" class="form-control" id="name" formControlName="name"
              [class.is-invalid]="name?.touched && name?.invalid">
            @if ((name?.touched || name?.dirty) && name?.invalid) {
              <div class="text-danger">
                @if (name?.hasError('required')) {
                  <div>Nome è obbligatorio.</div>
                }
                @if (name?.hasError('maxlength')) {
                  <div>Lunghezza Massima 255.</div>
                }
              </div>
            }
          </div>
          <div class="col-md-6">
            <label for="surname" class="form-label">Cognome</label>
            <input type="text" class="form-control" id="surname" formControlName="surname"
              [class.is-invalid]="surname?.touched && surname?.invalid">
            @if ((surname?.touched || surname?.dirty) && surname?.invalid) {
              <div class="text-danger">
                @if (surname?.hasError('required')) {
                  <div>Cognome è obbligatorio.</div>
                }
                @if (surname?.hasError('maxlength')) {
                  <div>Lunghezza Massima 255.</div>
                }
              </div>
            }
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-md-6">
            <label for="email" class="form-label">Indirizzo Email</label>
            <input type="email" class="form-control" id="email" formControlName="email" required
              [class.is-invalid]="(email?.touched || email?.dirty) && email?.invalid">
            @if ((email?.touched || email?.dirty) && email?.invalid) {
              <div class="text-danger">
                @if (email?.hasError('required')) {
                  <div>Indirizzo Email è obbligatorio.</div>
                }
                @if (email?.hasError('email')) {
                  <div>Indirizzo Email non è un formato email valido.</div>
                }
              </div>
            }
          </div>
          <div class="col-md-6">
            <label for="telephone" class="form-label">Telefono</label>
            <div class="input-group">
              <span class="input-group-text">+39</span>
              <input type="telephone" class="form-control" id="telephone" formControlName="telephone"
                required
                [class.is-invalid]="(telephone?.touched || telephone?.dirty) && telephone?.invalid">
            </div>
            @if ((telephone?.touched || telephone?.dirty) && telephone?.invalid) {
              <div class="text-danger">
                @if (telephone?.hasError('required')) {
                  <div>Telefono è obbligatorio.</div>
                }
                @if (telephone?.hasError('invalidPhone')) {
                  <div>Inserisci un numero di telefono italiano
                  valido (fisso o mobile).</div>
                }
              </div>
            }
          </div>
        </div>
        @if (existedUser) {
          <div class="row mb-3">
            <div class="col-md-6">
              <label for="uid" class="form-label">UID</label>
              <input type="text" id="uid" class="form-control" [value]="existedUser?.uid" disabled>
            </div>
            <div class="col-md-6">
              <label for="createDate" class="form-label">Data Creazione</label>
              <input type="text" id="createDate" class="form-control"
                [value]="existedUser?.createDate | date:'dd/MM/yyyy HH:mm'" disabled>
              </div>
            </div>
          }

          <div class="d-flex justify-content-end">
            @if (!existedUser) {
              <app-loading-button class="me-3" [loading]="loading" [disabled]="userForm.invalid || loading"
              i18n>Crea Utente</app-loading-button>
              <button type="button" class="btn btn-secondary" (click)="onCancel()">Annulla</button>
            } @else {
              @if (userDisabled()) {
                <app-loading-button class="me-3" type="button" [loading]="loading" [disabled]="loading" i18n
                (clickButton)="confirmEnableDisableUser()">Abilita</app-loading-button>
              } @else {
                <app-loading-button class="me-3" type="button" buttonType="danger" [loading]="loading"
                  [disabled]="loading" i18n
                (clickButton)="confirmEnableDisableUser()">Disabilita</app-loading-button>
              }
              @if (existedUser?.emailVerified === false) {
                <app-loading-button type="button" buttonType="primary" [loading]="resendFirstAccessEmailLoading"
                  [disabled]="resendFirstAccessEmailLoading" i18n (clickButton)="resendFirstAccessEmail()">Reinvia
                        Link Primo Accesso</app-loading-button>
              }
            }
          </div>

          @if (existedUser) {
            <div class="mt-4 pt-3 border-top">
              <h5 class="mb-3">Informazioni aggiuntive</h5>

              <!-- Stessi badge/list per stato e liste -->
              <div class="row mb-3">
                <div class="col-md-6">
                  <div>Stato</div>
                  <span class="badge" [ngClass]="existedUser?.disabled ? 'bg-danger' : 'bg-success'">
                    {{ existedUser?.disabled ? 'Disabilitato' : 'Attivo' }}
                  </span>
                </div>
                <div class="col-md-6">
                  <div>Account</div>
                  <span class="badge"
                    [ngClass]="existedUser?.emailVerified ? 'bg-success' : 'bg-warning text-dark'">
                  {{ existedUser?.emailVerified ? 'Verificato' : 'Non verificato' }}
                </span>
              </div>
            </div>

            <!-- GROUPS -->
            <div class="row mb-3">
              <div class="col-md-6">
                <div class="mb-1">Gruppi</div>
                @if (existedUser?.groups?.length) {
                  @for (group of existedUser?.groups; track group.id) {
                    <span class="badge bg-info text-dark me-1">{{ group.name }}</span>
                  }
                } @else {
                  <div class="text-muted">Nessun gruppo</div>
                }
              </div>

              <!-- CONTEXTS -->
              <div class="col-md-6">
                <div class="mb-1">Contesti</div>
                @if (existedUser?.contexts?.length) {
                  @for (context of existedUser?.contexts; track context.id) {
                    <span class="badge bg-secondary me-1">{{ context.name }}</span>
                  }
                } @else {
                  <div class="text-muted">Nessun contesto</div>
                }
              </div>
            </div>
          </div>
        }
      </form>
    </div>
  </div>
</div>